import { CommissionAllocationService } from "../../services";
import { BaseService } from "../../services/base.service";
import { createCRUDThunks } from "../../shared/helpers/thunks.helpers";
import {
  CommissionAllocationFormValues,
  CommissionAllocationRequest,
  CommissionAllocationResponse,
} from "../../shared/types/commission-allocation.type";

const service = new CommissionAllocationService();

const basicThunks = createCRUDThunks<
  CommissionAllocationRequest,
  CommissionAllocationResponse,
  CommissionAllocationFormValues
>({
  service: service as unknown as BaseService<
    CommissionAllocationRequest,
    CommissionAllocationResponse,
    CommissionAllocationFormValues
  >,
  resourceName: "commissionable-services",
});

export const CommissionAllocationsThunks = {
  ...basicThunks,
};
